import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
// react component used to create a calendar with events on it
import BigCalendar from 'react-big-calendar';
// dependency plugin for react-big-calendar
import moment from 'moment';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';

// core components
import CustomTabs from 'components/CustomTabs/CustomTabs.jsx';
import Heading from 'components/Heading/Heading.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import ActionableSongList from 'components/ActionableSongList.jsx';
import LoaderWhite from 'components/LoaderWhite';
import { updateUserData } from 'store/actions/userActions';

// icons
import FavoriteIcon from '@material-ui/icons/Favorite';
import LibraryMusicIcon from '@material-ui/icons/LibraryMusic';

// Images
import Album1 from 'assets/img/album1.jpg';
import Album2 from 'assets/img/album2.jpg';
import Album3 from 'assets/img/album3.jpg';
import Album4 from 'assets/img/album4.jpg';
import buttonStyle from 'assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx';

const localizer = BigCalendar.momentLocalizer(moment);

const Library = ({ classes, favoriteSongs, uid }) =>
  !uid ? (
    <LoaderWhite />
  ) : (
    <div>
      <Heading textAlign='center' />
      <GridContainer
        style={{ width: '128%', marginLeft: '-14%', marginTop: '100px' }}
      >
        <GridItem xs={12}>
          <Card
            style={{
              margin: '0px 0px 0px 0px',
              height: '80px',
              borderRadius: '30px 30px 0px 0px',
              backgroundColor: '#FFFFFF',
            }}
            paper='true'
          />
          <Card
            style={{
              padding: '0px 0px 30px 20px',
              borderRadius: '0px',
              boxShadow: 'none',
              margin: '-5px 0px -29px',
              backgroundColor: '#FFFFFF',
            }}
            paper='true'
          >
            <div>
              <CustomTabs
                headerColor='primary'
                tabs={[
                  {
                    tabName: 'Collections',
                    tabIcon: LibraryMusicIcon,
                    tabContent: (
                      <div style={{ padding: '0px 35px 0px 0px' }}>
                        <GridContainer
                          className={classes.mobileAlbum}
                          style={{ width: '100%', padding: '0px 0px 0px 3%' }}
                        >
                          {/* List Item 1 */}

                          <GridItem
                            style={{ margin: '0px 0px 10px 0px' }}
                            xs={4}
                            sm={2}
                            md={2}
                            lg={2}
                          >
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '10px 0px 0px 0px',
                              }}
                              src={Album1}
                              alt='Album Artwork'
                            />
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '0px 10px 0px 0px',
                              }}
                              src={Album2}
                              alt='Album Artwork'
                            />
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '0px 0px 0px 10px',
                              }}
                              src={Album3}
                              alt='Album Artwork'
                            />
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '0px 0px 10px 0px',
                              }}
                              src={Album4}
                              alt='Album Artwork'
                            />
                          </GridItem>
                          <GridItem xs={8} sm={10} md={10} md={10} lg={10}>
                            <p
                              style={{
                                fontSize: '18px',
                                margin: '26px 0px 0px 0px',
                              }}
                              className={classes.description}
                            >
                              <b>Chill Hip-Hop</b>
                            </p>
                            <p
                              style={{ color: '#AAAAAA' }}
                              className={classes.description}
                            >
                              <b>26 Songs</b>
                            </p>
                          </GridItem>

                          {/* List Item 2 */}

                          <GridItem
                            style={{ margin: '0px 0px 10px 0px' }}
                            xs={4}
                            sm={2}
                            md={2}
                            lg={2}
                          >
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '10px 0px 0px 0px',
                              }}
                              src={Album1}
                              alt='Album Artwork'
                            />
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '0px 10px 0px 0px',
                              }}
                              src={Album2}
                              alt='Album Artwork'
                            />
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '0px 0px 0px 10px',
                              }}
                              src={Album3}
                              alt='Album Artwork'
                            />
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '0px 0px 10px 0px',
                              }}
                              src={Album4}
                              alt='Album Artwork'
                            />
                          </GridItem>
                          <GridItem xs={8} sm={10} md={10} md={10}>
                            <p
                              style={{
                                fontSize: '18px',
                                margin: '26px 0px 0px 0px',
                              }}
                              className={classes.description}
                            >
                              <b>Festival EDM</b>
                            </p>
                            <p
                              style={{ color: '#AAAAAA' }}
                              className={classes.description}
                            >
                              <b>26 Songs</b>
                            </p>
                          </GridItem>

                          {/* List Item 3 */}

                          <GridItem
                            style={{ margin: '0px 0px 10px 0px' }}
                            xs={4}
                            sm={2}
                            md={2}
                            lg={2}
                          >
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '10px 0px 0px 0px',
                              }}
                              src={Album1}
                              alt='Album Artwork'
                            />
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '0px 10px 0px 0px',
                              }}
                              src={Album2}
                              alt='Album Artwork'
                            />
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '0px 0px 0px 10px',
                              }}
                              src={Album3}
                              alt='Album Artwork'
                            />
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '0px 0px 10px 0px',
                              }}
                              src={Album4}
                              alt='Album Artwork'
                            />
                          </GridItem>
                          <GridItem xs={8} sm={10} md={10} md={10}>
                            <p
                              style={{
                                fontSize: '18px',
                                margin: '26px 0px 0px 0px',
                              }}
                              className={classes.description}
                            >
                              <b>Acoustic Music</b>
                            </p>
                            <p
                              style={{ color: '#AAAAAA' }}
                              className={classes.description}
                            >
                              <b>26 Songs</b>
                            </p>
                          </GridItem>

                          {/* List Item 4 */}

                          <GridItem
                            style={{ margin: '0px 0px 10px 0px' }}
                            xs={4}
                            sm={2}
                            md={2}
                            lg={2}
                          >
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '10px 0px 0px 0px',
                              }}
                              src={Album1}
                              alt='Album Artwork'
                            />
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '0px 10px 0px 0px',
                              }}
                              src={Album2}
                              alt='Album Artwork'
                            />
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '0px 0px 0px 10px',
                              }}
                              src={Album3}
                              alt='Album Artwork'
                            />
                            <img
                              style={{
                                margin: '0px',
                                width: '50%',
                                borderRadius: '0px 0px 10px 0px',
                              }}
                              src={Album4}
                              alt='Album Artwork'
                            />
                          </GridItem>
                          <GridItem
                            style={{ margin: '0px 0px 60px 0px' }}
                            xs={8}
                            sm={10}
                            md={10}
                            md={10}
                          >
                            <p
                              style={{
                                fontSize: '18px',
                                margin: '26px 0px 0px 0px',
                              }}
                              className={classes.description}
                            >
                              <b>Folk Tunes</b>
                            </p>
                            <p
                              style={{ color: '#AAAAAA' }}
                              className={classes.description}
                            >
                              <b>26 Songs</b>
                            </p>
                          </GridItem>
                        </GridContainer>
                      </div>
                    ),
                  },
                  {
                    tabName: 'Favorites',
                    tabIcon: FavoriteIcon,
                    tabContent: (
                      <div style={{ padding: '10px 35px 0px 25px' }}>
                        <ActionableSongList
                          data={favoriteSongs}
                          listType='favoriteSongs'
                        />
                      </div>
                    ),
                  },
                ]}
              />
            </div>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );

Library.defaultProps = {
  favoriteSongs: [],
};

const mapStateToProps = (state, ownProps) => {
  const { favoriteSongs, uid } = state.user;
  return { favoriteSongs, uid };
};

export default compose(
  connect(mapStateToProps, { updateUserData }),
  withStyles(buttonStyle)
)(Library);
